// removed by extract-text-webpack-plugin
module.exports = {"error-msg":"InlineError__error-msg","errorMsg":"InlineError__error-msg","show-error-msg":"InlineError__show-error-msg","showErrorMsg":"InlineError__show-error-msg"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/InlineError/InlineError.scss
// module id = 352
// module chunks = 8